import React, { useState, useEffect, useRef } from 'react';
import { Table, Button, Drawer, Checkbox, Toggle, ExpandableSection, FlashbarProps, Flashbar, Select, FormField, Multiselect, TimeInput, DateRangePicker, DateRangePickerProps, Input, Container, Modal, Calendar, RadioGroup, Link, Form, Badge } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import { useGlobalState } from '../../../context/GlobalStateContext';
import Icon from "@cloudscape-design/components/icon";
import { formatPhone, isEmail, isValidPhone, storeJWT } from '../../../commons/functions';
import { format, addHours } from 'date-fns';
import { formatInTimeZone } from "date-fns-tz";
import { useStoreAdmin } from '../../../context/useStoreAdmin';

interface Unit {
    label: string;
    value: string;
    description?: string;
    canHandleGuests: number;
    unidad: string;
    idUnidad: number;
    users: number;
    disabled: boolean,
}

interface User {
    label: string;
    value: string;
    description?: string;
}

interface Access {
    label: string;
    value: string;
    description?: string;
    canHandleGuests: number;
    acceso: string;
    idAcceso: number;
}
interface Props {
    accesses: Access[]; // The array of all available access options
    onAccessChange: (selectedAccesses: Access[]) => void; // Callback to handle changes
    initialAccess?: Access[]; // Optional initial selected values
}
export const InvitationsAddPage = () => {
    const storeAdmin = useStoreAdmin();
    const earlierDate = formatInTimeZone(new Date(), "America/Santiago", "yyyy-MM-dd'T'HH:mm:ss");

    const [messages, setMessages] = useState<FlashbarProps.MessageDefinition[]>([]);
    const [modalMessages, setModalMessages] = useState<FlashbarProps.MessageDefinition[]>([]);

    const { idPropiedad, setIdPropiedad } = useGlobalState();
    const { JWT, setJWT } = useGlobalState();

    const { gData, setGData } = useGlobalState();
    //const { gData, setGData } = useGlobalState();


    const [btnAuths, setBtnAuths] = useState(true);
    const [DPVisible, setDPVisible] = useState(false);
    const [allDay, setAllDay] = useState(false);

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();
    const { setLoading } = useGlobalState();
    const [loadingGenerate, setLoadingGenerate] = useState<boolean>(false);
    const [verifyGuest, setVerifyGuest] = useState<boolean>(false);
    const [showUnit, setShowUnit] = useState<boolean>(false);
    const [unitsDisable, setUnitsDisable] = useState<boolean>(false);
    const [startTime, setStartTime] = useState<string>('');
    const [date, setDate] = useState<string>('');
    const [extension, setExtension] = useState<string>('');
    const [subject, setSubject] = useState<string>('');
    const [dateString, setDateString] = useState<string>('Haga click en "Establecer" para seleccionar fecha/hora');
    const [guest, setGuest] = useState<string>('');
    const [guestInputs, setGuestInputs] = useState<{ phone: string; displayName: string; email: string; }[]>([]);


    //const [date, setDate] = React.useState(undefined);
    const now = new Date();
    const oneHourLater = new Date(now.getTime() + 60 * 60 * 1000); // Add 1 hour in milliseconds

    const [value, setValue] = useState<DateRangePickerProps.Value>({
        type: "absolute",
        startDate: formatInTimeZone(new Date(), "America/Santiago", "yyyy-MM-dd'T'HH:mm:ss"), //now.toISOString().slice(0, 19), // Format to 'YYYY-MM-DDTHH:mm:ss'
        endDate: formatInTimeZone(addHours(new Date(), 1), "America/Santiago", "yyyy-MM-dd'T'HH:mm:ss"), //oneHourLater.toISOString().slice(0, 19), // Format to 'YYYY-MM-DDTHH:mm:ss'
    });

    const [users, setUsers] = useState<User[]>([]);
    const [user, setUser] = useState<User | undefined>();
    const [filteredUsers, setFilteredUsers] = useState<User[]>([]);

    const [units, setUnits] = useState<Unit[]>([]);
    const [unit, setUnit] = useState<Unit | undefined>();
    const [accesses, setAccesses] = useState<Access[]>([]);
    const [access, setAccess] = useState<Access[]>([]);



    const handleGenerate = async () => {

        if (user === undefined) {
            setMessages([
                {
                    type: 'error',
                    content: 'Seleccione un anfitrión.',
                    dismissible: true,
                }
            ]);
            return;
        }
        if (access.length === 0) {
            setMessages([
                {
                    type: 'error',
                    content: 'Seleccione al menos un acceso.',
                    dismissible: true,
                }
            ]);
            return;
        }

        if (date.length !== 10 || ((startTime.length !== 5 || extension === "") && !allDay)) {
            setMessages([
                {
                    type: 'error',
                    content: 'Seleccione los horarios.',
                    dismissible: true,
                }
            ]);
            return;
        }

        if (guestInputs.length === 0) {
            setMessages([
                {
                    type: 'error',
                    content: 'Ingrese al menos un invitado.',
                    dismissible: true,
                }
            ]);
            return;
        }

        const Accesses: { idAcceso: number }[] = [];
        const Guests: { movil: string, name: string }[] = [];
        access.forEach(item => {
            Accesses.push({ idAcceso: parseInt(item.value || "0") });
        });

        guestInputs.forEach(item => {
            Guests.push({ movil: item.phone.replace(/\D/g, ''), name: item.displayName });
        });

        let startDateObj = new Date(date + "T00:00:00"); // Assumes `date` is a valid ISO date string
        let endDateObj = new Date(date + "T00:00:00"); // Assumes `date` is a valid ISO date string
        if (!allDay) {
            startDateObj = new Date(date + "T00:00:00"); // Assumes `date` is a valid ISO date string
            const [hours, minutes] = startTime.split(':').map(Number);
            startDateObj.setHours(hours);
            startDateObj.setMinutes(minutes);
            endDateObj = addHours(startDateObj, Number(extension));
        }
        const body = {
            idUnidad: parseInt(unit?.value || "0"),
            idControl: parseInt(user?.value || "0"),
            invitacion: subject,
            allDay: (allDay ? 1 : 0),
            startDate: format(startDateObj, 'dd-MM-yyyy HH:mm'),
            endDate: format(endDateObj, 'dd-MM-yyyy HH:mm'),
            access: Accesses,
            guests: Guests,
        }
        setMessages([])
        setLoadingGenerate(true)
        try {
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/guests/add',
                    'JWT': JWT,

                },
                body: JSON.stringify(body)
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {
                console.log(data);
                window.location.hash = "#invitations/list"
            } else {

                setMessages([
                    {
                        type: 'error',
                        content: `Error al contactar el servidor: ${data.status}`,
                        id: 'server-error',
                    },
                ]);
            }

        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            //setPendingJobCreation(false);

            setLoadingGenerate(false)
        }

        ///

    }
    const [rawUnits, setRawUnits] = useState<any[]>([]);
    const [rawAccesses, setRawAccesses] = useState<any[]>([]);
    const handleGetUnits = async () => {
        try {

            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/units/list',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    columns: "idUnidad, unidad, allowDistanceOpenInmueble, isBlockUnit, reqInfoUnidad, reqInfoTitle, canHandleGuests, (select count(distinct idControl) from Autorizados where idInmueble=Inmuebles.idInmueble) as users "
                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();

            setRawUnits(data.units);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const mapped: Unit[] = rawUnits
            .filter((item: { unidad: string; idUnidad: number; canHandleGuests: number, users: number }) => item.canHandleGuests === 1)
            .map((item: { unidad: string; idUnidad: number; canHandleGuests: number, users: number }) => ({
                label: item.unidad,
                value: item.idUnidad.toString(),
                canHandleGuests: item.canHandleGuests,
                unidad: item.unidad,
                idUnidad: item.idUnidad,
                users: item.users,
                disabled: item.users === 0,
            }));
        setUnits(mapped);
        setUnitsDisable(mapped.length === 0);

        setMessages([]);
        if (mapped.length === 0) {
            setMessages([{
                type: "warning",
                content: 'Propiedad no tiene unidades con capacidad de gestionar invitados',
                dismissible: false,
            }])
        }
    }, [rawUnits]);



    useEffect(() => {
        handleGetUnits()
    }, []);
    useEffect(() => {
        setMessages([]);
    }, [guest]);
    const handleAddUser = async () => {
        const normalizedPhone = guest.replace(/\D/g, '');
        //console.log("1")
        const alreadyExists = guestInputs.some(g => g.phone.replace(/\D/g, '') === normalizedPhone);
        //console.log("2")
        if (alreadyExists) {
            setMessages([
                {
                    type: "warning",
                    content: 'Este número ya ha sido agregado.',
                    dismissible: true,
                    onDismiss: () => {
                        setMessages([]);
                    }
                }
            ]);
            return;
        }
        setVerifyGuest(true)
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/users/preregister',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    movil: guest,
                }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);

            }
            const data = await response.json();

            storeAdmin(data);
            if (data.code === 0) {
                console.log(data)
                setGuestInputs(prev => [...prev, { phone: formatPhone(guest), displayName: data.user.displayName, email: data.user.email }]);
                setGuest(''); // optionally reset input
            }


        } catch (error: any) {
            setMessages([
                {
                    type: 'error',
                    content: `Error al contactar el servidor: ${error.message}`,
                    id: 'server-error',
                },
            ]);
        } finally {
            //setPendingJobCreation(false);
            setVerifyGuest(false)
            setMessages([]);
            setLoading(false);
        }

    };
    const handleGetUsers = async () => {
        setMessages([]);
        setUsers([]);
        setShowUnit(false);
        try {
            setLoading(true);
            const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx?3', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/admin/units/getunit',
                    'JWT': JWT,

                },
                body: JSON.stringify({
                    idUnidad: unit?.value

                })
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            storeAdmin(data);
            if (data.code === 0) {

                const mappedUsers: User[] = data.unit.users.map((item: { displayName: string; idControl: string; movil: string; }) => ({
                    //label: `${item.displayName} (${formatPhone(item.movil)})`,
                    label: item.displayName + ' (' + formatPhone(item.movil) + ')',
                    value: item.idControl.toString(),
                }));
                setUsers(mappedUsers)
                // When users are loaded or updated, set filteredUsers to the full list
                setFilteredUsers(users);
                if (mappedUsers.length === 1) {
                    setUser(mappedUsers[0]);
                }
                const mappedAccesses: Access[] = data.accesses
                    .filter((item: { canHandleGuests?: number }) => item.canHandleGuests === 1)
                    .map((item: { acceso: string; idAcceso: string; canHandleGuests: number }) => ({
                        label: item.acceso,
                        value: item.idAcceso.toString(),
                        idAcceso: item.idAcceso,
                        acceso: item.acceso,
                        canHandleGuests: item.canHandleGuests
                    }));

                setAccesses(mappedAccesses);

            }
            setShowUnit(true);
            //setUsers(data.admins);

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        setShowUnit(false);
        setUsers([]);
        if (unit !== undefined) {
            handleGetUsers();
        }
    }, [unit]);
    //'System.Object[]'
    const handleSetDate = () => {
        setModalMessages([]);
        if (date.length !== 10) {
            setModalMessages([
                {
                    type: 'error',
                    content: `Debe seleccionar el día de la invitación.`,
                    id: 'server-error',
                    dismissible: true,
                    onDismiss: () => setModalMessages([])
                },
            ])
            return;
        }
        if (!allDay) {
            if (startTime.length !== 5) {
                setModalMessages([
                    {
                        type: 'error',
                        content: `Debe ingresar la hora de inicio.`,
                        id: 'server-error',
                        dismissible: true,
                        onDismiss: () => setModalMessages([])
                    },
                ])
                startTimeRef.current?.querySelector('input')?.focus(),
                    startTimeRef.current?.querySelector('input')?.select()
                return;
            }
            if (extension === "") {
                setModalMessages([
                    {
                        type: 'error',
                        content: `Debe ingresar la extensión de la invitación en horas.`,
                        id: 'server-error',
                        dismissible: true,
                        onDismiss: () => setModalMessages([])
                    },
                ])

                extensionRef.current?.querySelector('input')?.focus(),
                    extensionRef.current?.querySelector('input')?.select()
                return;
            }
        }
        setDateString(`El ${format(new Date(date), 'dd MMMM yyyy')} ${allDay ? 'válida por todo el día' : `desde las ${startTime} por ${extension} horas`}`);
        setDPVisible(false)
        setMessages([]);
        setModalMessages([]);
    }
    const handleChangeAccesos = ({ detail }: { detail: { selectedOptions: Access[] } }) => {
        setAccess(detail.selectedOptions);
        setMessages([]);
        //onAccessChange(detail.selectedOptions); // Call the callback with the new selection
    };
    const startTimeRef = useRef<HTMLDivElement>(null);
    const extensionRef = useRef<HTMLDivElement>(null);



    return (
        <CustomAppLayout
            toolsHide={true}

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={[
                        { text: 'Inicio', href: '#home' },
                        { text: 'Invitaciones', href: '#invitations/default' },
                        { text: 'Generar', href: '#transcription-job-list' },
                        /*{ text: 'Listar notificaciones', href: '#create-transcription-job' },*/
                    ]}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <Form
                        actions={
                            <SpaceBetween direction="horizontal" size="xs">

                                <Button loading={loadingGenerate} disabled={!showUnit} variant='primary' onClick={() => handleGenerate()}>
                                    Generar
                                </Button>
                            </SpaceBetween>
                        }
                        header={<Header variant="h1">Generar invitación</Header>}
                    >
                        <Container>
                            <Flashbar items={messages} />
                            <SpaceBetween direction="vertical" size="xs">

                                <SpaceBetween direction="horizontal" size="xs">
                                    <FormField
                                        description="Seleccione unidad para desplegar usuarios."
                                        label="Unidad"
                                    >
                                        <Select
                                            selectedOption={unit ?? null}
                                            loadingText='Cargando unidades...'
                                            onChange={({ detail }) => {
                                                console.log(detail.selectedOption)
                                                setUnit(detail.selectedOption as Unit);
                                                setUser(undefined)
                                            }}
                                            disabled={unitsDisable}
                                            options={units}
                                            placeholder="Seleccionar"
                                            filteringType="auto"
                                        //selectedOption={null}
                                        ></Select>
                                    </FormField>
                                    {showUnit && (
                                        <FormField
                                            description="Seleccione usuario que genera la invitación (Anfitrión)."
                                            label="Anfitrión"
                                        >
                                            <Select
                                                loadingText='Cargando usuarios...'
                                                selectedOption={user ?? null}
                                                onChange={({ detail }) => {
                                                    setUser(detail.selectedOption as User);
                                                    setMessages([]);
                                                }}

                                                options={filteredUsers}
                                                placeholder="Seleccionar"
                                                filteringType="manual"
                                                onLoadItems={({ detail }) => {
                                                    const query = detail.filteringText.toLowerCase();
                                                    const words = query.split(/\s+/).filter(Boolean); // Split and remove empty parts

                                                    const results = users.filter(user => {
                                                        const label = `${user.label}`.toLowerCase(); // or any searchable fields concatenated
                                                        return words.every(word => label.includes(word));
                                                    });

                                                    setFilteredUsers(results); // You'll need `const [filteredUsers, setFilteredUsers] = useState<User[]>(users);`
                                                }}
                                            //selectedOption={null}
                                            ></Select>
                                        </FormField>
                                    )}
                                </SpaceBetween>
                                {showUnit && (
                                    <>
                                        <FormField
                                            description="Título de la invitación."
                                            label="Asunto"
                                            constraintText="*Campo opcional"

                                        >
                                            <Input
                                                value={subject}
                                                onChange={({ detail }) => {
                                                    setSubject(detail.value)
                                                    setMessages([]);
                                                }}
                                                placeholder=""
                                            ></Input>
                                        </FormField>

                                        <FormField
                                            description="Seleccione al menos un acceso al invitado."
                                            label={`Accesos ${access.length === 0 ? "" : `(${access.length})`}`}

                                        >
                                            <Multiselect
                                                loadingText='Cargando accesos...'
                                                selectedOptions={access ?? null}
                                                onChange={({ detail }) => {
                                                    setAccess(detail.selectedOptions as Access[])
                                                    setMessages([]);
                                                }
                                                }
                                                options={accesses}
                                                placeholder="Seleccionar"
                                                filteringType="auto"
                                            //selectedOption={null}
                                            ></Multiselect>
                                        </FormField>

                                        <FormField
                                            description={dateString}
                                            label="Horarios"
                                            info={<Link onClick={() => setDPVisible(true)}><Badge color="blue">Establecer</Badge></Link>}
                                        ></FormField>
                                        <FormField
                                            description="Ingrese el número de móvil (formato 56 9 8765 4321)."
                                            label={`Invitados ${guestInputs.length === 0 ? "" : `(${guestInputs.length})`}`}

                                        >
                                            <SpaceBetween direction="horizontal" size="xs">
                                                <Input
                                                    value={guest}
                                                    onChange={({ detail }) => {
                                                        setGuest(detail.value.replace(/\D/g, ''));
                                                        setMessages([]);
                                                    }}
                                                    placeholder=""

                                                    onKeyDown={(e) => {
                                                        if (e.detail.key === 'Enter' && isValidPhone(guest.replace(/\D/g, ''))) {
                                                            handleAddUser()
                                                        }
                                                    }}
                                                ></Input>
                                                <Button variant='primary' onClick={() => handleAddUser()} disabled={
                                                    !isValidPhone(guest.replace(/\D/g, ''))
                                                } loadingText='Verificando...' loading={verifyGuest} >
                                                    Agregar
                                                </Button>
                                            </SpaceBetween>
                                        </FormField>

                                        {guestInputs.map((guest, index) => (
                                            <Box key={index}>
                                                <SpaceBetween direction="horizontal" size="xs">
                                                    {index === 0 ? (
                                                        <FormField description="Móvil">
                                                            <Input
                                                                readOnly
                                                                value={guest.phone}
                                                                placeholder="Ej: 56 9 8765 4321"
                                                                onChange={({ detail }) => {
                                                                    const updated = [...guestInputs];
                                                                    updated[index].phone = detail.value;
                                                                    setGuestInputs(updated);
                                                                }}
                                                            />
                                                        </FormField>
                                                    ) : (
                                                        <Input
                                                            readOnly
                                                            value={guest.phone}
                                                            placeholder="Ej: 56 9 8765 4321"
                                                            onChange={({ detail }) => {
                                                                const updated = [...guestInputs];
                                                                updated[index].phone = detail.value;
                                                                setGuestInputs(updated);
                                                            }}
                                                        />
                                                    )}

                                                    {index === 0 ? (
                                                        <FormField description="Nombre">
                                                            <Input
                                                                readOnly={guest.displayName !== ''}
                                                                value={guest.displayName}
                                                                placeholder=""
                                                                onChange={({ detail }) => {
                                                                    const updated = [...guestInputs];
                                                                    updated[index].displayName = detail.value;
                                                                    setGuestInputs(updated);
                                                                }}
                                                            />
                                                        </FormField>
                                                    ) : (
                                                        <Input
                                                            readOnly={guest.displayName !== ''}
                                                            value={guest.displayName}
                                                            placeholder=""
                                                            onChange={({ detail }) => {
                                                                const updated = [...guestInputs];
                                                                updated[index].displayName = detail.value;
                                                                setGuestInputs(updated);
                                                            }}
                                                        />
                                                    )}
                                                    {index === 0 ? (
                                                        <FormField description="Email">
                                                            <Input
                                                                readOnly={isEmail(guest.email)}
                                                                value={guest.email}
                                                                placeholder=""
                                                                onChange={({ detail }) => {
                                                                    const updated = [...guestInputs];
                                                                    updated[index].email = detail.value;
                                                                    setGuestInputs(updated);
                                                                }}
                                                            />
                                                        </FormField>
                                                    ) : (
                                                        <Input
                                                            readOnly={isEmail(guest.email)}
                                                            value={guest.email}
                                                            placeholder=""
                                                            onChange={({ detail }) => {
                                                                const updated = [...guestInputs];
                                                                updated[index].email = detail.value;
                                                                setGuestInputs(updated);
                                                            }}
                                                        />
                                                    )}
                                                    {index === 0 ? (
                                                        <FormField description="·">
                                                            <Button
                                                                iconName="close"
                                                                variant="icon"
                                                                onClick={() => {
                                                                    const updated = [...guestInputs];
                                                                    updated.splice(index, 1);
                                                                    setGuestInputs(updated);
                                                                }}
                                                                ariaLabel="Eliminar invitado"
                                                            />
                                                        </FormField>
                                                    ) : (
                                                        <Button
                                                            iconName="close"
                                                            variant="icon"
                                                            onClick={() => {
                                                                const updated = [...guestInputs];
                                                                updated.splice(index, 1);
                                                                setGuestInputs(updated);
                                                            }}
                                                            ariaLabel="Eliminar invitado"
                                                        />
                                                    )}
                                                </SpaceBetween>
                                            </Box>
                                        ))}
                                    </>
                                )}
                            </SpaceBetween>
                        </Container>
                    </Form>
                    <Modal
                        onDismiss={() => setDPVisible(false)}
                        visible={DPVisible}
                        size='medium'
                        footer={
                            <Box float="right">
                                <SpaceBetween direction="horizontal" size="xs">
                                    <Button variant="link" onClick={() => { setDPVisible(false) }}>Cancelar</Button>
                                    <Button variant="primary" onClick={handleSetDate}>Ok</Button>
                                </SpaceBetween>
                            </Box>
                        }
                        header="Fecha/Hora"
                    >
                        <Flashbar items={modalMessages}></Flashbar>
                        <SpaceBetween direction='horizontal' size='xs'>
                            <Calendar
                                onChange={({ detail }) => {
                                    setDate(detail.value);
                                    setModalMessages([])
                                    setTimeout(() => {
                                        startTimeRef.current?.querySelector('input')?.focus()
                                        startTimeRef.current?.querySelector('input')?.select()
                                    }, 0);


                                }}
                                value={date}
                                isDateEnabled={(date) => {
                                    const today = new Date();
                                    today.setHours(0, 0, 0, 0); // Normalize to midnight
                                    return date >= today;
                                }}
                            />

                            <SpaceBetween direction='vertical' size='xs'>

                                <RadioGroup
                                    onChange={({ detail }) => {
                                        setAllDay(detail.value === "true" ? true : false)
                                        setModalMessages([]);
                                    }}
                                    value={allDay === false ? "false" : "true"}
                                    items={[
                                        { value: "false", label: "Duración limitada" }
                                    ]}
                                />
                                <FormField
                                    description="Hora de inicio de la invitación."
                                    label="Inicio"
                                >
                                    <div ref={startTimeRef}>
                                        <TimeInput
                                            disabled={allDay}
                                            //ref={startTimeRef}
                                            value={startTime}
                                            onChange={({ detail }) => {
                                                setStartTime(detail.value);
                                                setModalMessages([])
                                                if (detail.value.length === 5) {
                                                    //setTimeout(() => extensionRef.current?.focus(), 0);
                                                    setTimeout(() => {
                                                        extensionRef.current?.querySelector('input')?.focus()
                                                        extensionRef.current?.querySelector('input')?.select()
                                                    }, 0)
                                                }
                                            }}
                                            placeholder='HH:MM'
                                            format='hh:mm'

                                        />
                                    </div>
                                </FormField>

                                <FormField
                                    description="Duración de la invitación (horas)."
                                    label="Extensión"
                                >
                                    <div ref={extensionRef}>
                                        <Input
                                            disabled={allDay}
                                            //ref={extensionRef}
                                            type='number'
                                            value={extension}
                                            onChange={({ detail }) => {
                                                setExtension(detail.value);
                                                setModalMessages([])
                                            }}
                                            step={1}
                                            onKeyDown={(e) => {
                                                if (e.detail.key === 'Enter') {
                                                    handleSetDate()
                                                }
                                            }}
                                        />
                                    </div>
                                </FormField>
                                <RadioGroup
                                    onChange={({ detail }) => setAllDay(detail.value === "true" ? true : false)}
                                    value={allDay === true ? "true" : "false"}
                                    items={[
                                        { value: "true", label: "Todo el día" },
                                    ]}
                                />
                            </SpaceBetween>
                        </SpaceBetween>
                    </Modal>

                </>
            }
        />
    );
};
